import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

const CheckoutForm = ({ amount, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [succeeded, setSucceeded] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setSubmitting(true);
    setError(null);

    const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.href },
      redirect: 'if_required',
    });

    if (confirmError) {
      setError(confirmError.message || 'Payment failed. Please try again.');
      setSubmitting(false);
      return;
    }

    if (paymentIntent && paymentIntent.status === 'succeeded') {
      setSucceeded(true);
      onSuccess?.();
    }

    setSubmitting(false);
  };

  if (succeeded) {
    return (
      <div className="alert alert-success text-sm mb-0">
        Payment received. Your KAX is on its way to your wallet.
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {error && (
        <div className="alert alert-danger text-sm mt-3 mb-0">{error}</div>
      )}
      <button
        type="submit"
        className="btn btn-custom-theme-active w-100 py-3 mt-4 text-white font-semibold"
        disabled={!stripe || submitting}
        style={{ borderRadius: '12px', fontSize: '1rem', letterSpacing: '0.5px' }}
      >
        {submitting ? 'Processing...' : `Pay $${amount}`}
      </button>
    </form>
  );
};

const StripePaymentForm = ({ clientSecret, amount, theme, onSuccess }) => {
  const options = {
    clientSecret,
    appearance: { theme: theme === 'dark' ? 'night' : 'stripe' },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm amount={amount} onSuccess={onSuccess} />
    </Elements>
  );
};

export default StripePaymentForm;
